import { Navigate, useSearchParams } from "react-router-dom";
import {
  NJSpinner,
  NJInlineMessage,
} from "@engie-group/fluid-design-system-react";
import { useAuth } from "./useAuth";

/** Renders the Okta redirect/callback state; shows debug diagnostics only with `?debugAuth=1`. */
export function LoginPage() {
  const { authenticated, loading, error, diagnostics } = useAuth();
  const [searchParams] = useSearchParams();
  const debugAuth = searchParams.get("debugAuth") === "1";

  if (loading) {
    return (
      <div className="flex h-dvh items-center justify-center">
        <NJSpinner aria-label="Authenticating" />
      </div>
    );
  }

  if (authenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex h-dvh flex-col items-center justify-center gap-3 bg-nj-neutral-primary-default p-6">
      <div className="text-sm text-nj-neutral-secondary-default">
        Redirection vers l&apos;authentification…
      </div>
      {error && debugAuth ? (
        <NJInlineMessage variant="error">
          Okta authentication error: {error}
        </NJInlineMessage>
      ) : null}
      {diagnostics && debugAuth ? (
        <pre className="w-full max-w-3xl whitespace-pre-wrap text-xs">
          {diagnostics}
        </pre>
      ) : null}
    </div>
  );
}
